import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type CaseMenuBarBase from "@/components/CaseMenuBar.Base.vue";

export default defineMosaicComponent<typeof CaseMenuBarBase>("components/CaseMenuBar");
